import { useEffect, useState } from "react";

export const useI18nLoader = (loaderFn) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      await loaderFn();
      if (mounted) setReady(true);
    };

    load();

    return () => {
      mounted = false;
    };
  }, [loaderFn]);

  return ready;
};
